import React from "react";

export default function SystemAnnouncementPage({ onLogout }) {
  const container = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--background-color)",
    color: "var(--text-color)",
    fontFamily: "inherit",
    padding: 24,
    textAlign: "center",
  };

  const card = {
    background: "var(--card-background-color)",
    borderRadius: "var(--border-radius)",
    boxShadow: "var(--box-shadow)",
    maxWidth: 480,
    width: "100%",
    padding: "48px 32px",
  };

  const heading = { margin: "0 0 16px", fontSize: 28, fontWeight: 700 };
  const body = { margin: "0 0 12px", fontSize: 16, lineHeight: 1.6 };

  const logoutButton = {
    marginTop: 24,
    padding: "10px 28px",
    fontSize: 15,
    fontWeight: 600,
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    background: "var(--primary-color, #4f46e5)",
    color: "#fff",
  };

  return (
    <div style={container}>
      <div style={card}>
        <img
          src="/logo color TM.svg"
          alt="Study Buddy"
          style={{ height: 48, margin: "0 auto 24px" }}
        />

        <h1 style={heading}>System Temporarily Unavailable</h1>

        <p style={body}>
          Due to the ongoing war, StudyBuddy is temporarily unavailable.
        </p>

        {onLogout && (
          <button style={logoutButton} onClick={onLogout}>
            Log Out
          </button>
        )}
      </div>
    </div>
  );
}
